import React from 'react';
import PropTypes from 'prop-types';
import { FilterButton } from 'components/Filtering';
import uniqueId from 'components/common/uniqueId';

const HeaderBar = ({
  title, showFilter, showTitle, capitalize, inverted, toolbar, onToggleSider, showSider
}) => {
  const headerClassName = inverted ? 'bhp-header-bar bhp-inverted' : 'bhp-header-bar';
  const titleClassName = capitalize ? 'bhp-title bhp-capitalize' : 'bhp-title';
  return (
    <div id={`HeaderBar-${uniqueId(title)}`} className={headerClassName}>
      {showFilter && (
        <div className="bhp-commands">
          <FilterButton active={showSider} type="filter" onToggleSider={onToggleSider} />
        </div>
      )}
      {showTitle && (
        <div className={titleClassName}>
          {title}
        </div>
      )}
      {toolbar}
    </div>
  );
};

HeaderBar.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  showTitle: PropTypes.bool,
  showFilter: PropTypes.bool,
  capitalize: PropTypes.bool,
  inverted: PropTypes.bool,
  toolbar: PropTypes.element,
  onToggleSider: PropTypes.func,
  showSider: PropTypes.bool
};

HeaderBar.defaultProps = {
  title: '',
  showTitle: true,
  showFilter: false,
  capitalize: true,
  inverted: false,
  toolbar: null,
  onToggleSider() {
  },
  showSider: false
};

export default HeaderBar;
